/**
 * CDN URL configuration
 *
 * Centralizes the CloudFront CDN domain used for images, audio, and other
 * static assets. Set REACT_APP_CDN_URL at build time to override the default.
 */
export const CDN_URL = process.env.REACT_APP_CDN_URL || 'https://d598mmm7zleni.cloudfront.net';

/** Public dojo price list (tuition, fees, uniforms & equipment), hosted on the CDN. */
export const PRICE_LIST_PDF_URL = `${CDN_URL}/docs/owaza-dojo-price-list.pdf`;
